import React from 'react';

import dayjs from 'dayjs';
import { Navigate } from 'react-router-dom';

import { makeAuditRoute } from '@/components/Audit/utils';
import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';
import { contractDetailsRoutes } from '@/pages/ContractDetails/routes';

const CounterpartyDetails = React.lazy(
  () => import('@/pages/CounterpartyDetails'),
);
const Information = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/Information'),
);
const Contracts = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/Contracts'),
);
const ConsumptionByCounterparty = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/ConsumptionByCounterparty'),
);
const EicCodeHistory = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/EicCodeHistory'),
);
const Documents = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/Documents'),
);
const ContractDetails = React.lazy(() => import('@/pages/ContractDetails'));
const ContractAddendumForm = React.lazy(
  () => import('@/pages/ContractAddendumForm'),
);
const ContractAddendumDetails = React.lazy(
  () => import('@/pages/ContractAddendumDetails'),
);
const CounterpartyAudit = React.lazy(() => import('@/pages/CounterpartyAudit'));

const counterpartyRoute = [
  {
    path: `${Pages.COUNTERPARTIES}/:category/:counterpartId`,
    element: <CounterpartyDetails />,
    children: [
      { index: true, element: <Information /> },
      {
        path: Pages.CONSUMPTION_BY_COUNTERPARTY,
        children: [
          {
            index: true,
            element: <Navigate to={String(dayjs().year())} replace />,
          },
          { path: ':year', element: <ConsumptionByCounterparty /> },
        ],
      },
      { path: Pages.CONTRACTS, element: <Contracts /> },
      { path: Pages.EIC_CODE_HISTORY, element: <EicCodeHistory /> },
      { path: Pages.COUNTERPARTY_DOCUMENTS, element: <Documents /> },
    ],
  },
  {
    path: `${Pages.COUNTERPARTIES}/:category/:counterpartId/${Pages.CONTRACT_DETAILS}`,
    element: <ContractDetails />,
    children: contractDetailsRoutes,
  },
  {
    path: `${Pages.COUNTERPARTIES}/:category/:counterpartId/${Pages.CONTRACT_DETAILS}/${Pages.CONTRACT_ADDENDA_CREATE_PART}`,
    element: <ContractAddendumForm />,
    handle: { permissions: UserPermissions.OrganizationsContractsWrite },
  },
  {
    path: `${Pages.COUNTERPARTIES}/:category/:counterpartId/${Pages.CONTRACT_DETAILS}/${Pages.CONTRACT_ADDENDUM_DETAILS_PART}`,
    element: <ContractAddendumDetails />,
  },
  makeAuditRoute(
    `${Pages.COUNTERPARTIES}/:category/:counterpartId`,
    <CounterpartyAudit />,
    UserPermissions.ConsumptionAccountingCounterpartiesRead,
  ),
];

export default counterpartyRoute;
